/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import "./TopHeader.scss";
import { BsArrowsFullscreen } from "react-icons/bs";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { buildMySchneiderUrl } from "../../utils/api/api";
import t from "../../utils/translation/translator";
import {
  selectConfigurationType,
  selectFullScreen,
  setFullScreen,
  selectSeamlessSession
} from "../../store/slices/common";
import { isStartStep } from "../../store/utils/utils";
import { selectPartnerPreferences, selectRetrofitCurrentStep } from "../../../Retrofit/store/slices/retrofit";
import { selectCartesianCurrentStep } from "../../../Cartesian/store/slices/cartesian";
import { selectMc12CurrentStep } from "../../../Mc12/store/slices/mc12";
import { selectIntegratedDrivesCurrentStep } from "../../../IntegratedDrives/store/slices/integrated_drives";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";

/**
 * Sub header of the app.
 */
const TopHeader = ({ ...props }) => {
  const dispatch = useDispatch();
  const fullScreen = useSelector(selectFullScreen);
  const handleSetFullScreen = () => {
    dispatch(setFullScreen(!fullScreen));
  };
  const configurationType = useSelector(selectConfigurationType);
  const retrofitCurrentStep = useSelector(selectRetrofitCurrentStep);
  const cartesianCurrentStep = useSelector(selectCartesianCurrentStep);
  const mc12CurrentStep = useSelector(selectMc12CurrentStep);
  const integratedDrivesCurrentStep = useSelector(selectIntegratedDrivesCurrentStep);
  const partnerPreferences = useSelector(selectPartnerPreferences);
  const seamlessSession = useSelector(selectSeamlessSession);
  const isMobile = useCheckMobileScreen();

  let currentStep = retrofitCurrentStep;
  if (configurationType === "CARTESIAN") {
    currentStep = cartesianCurrentStep;
  } else if (configurationType === "MC12") {
    currentStep = mc12CurrentStep;
  } else if (configurationType === "INTEGRATED_DRIVES") {
    currentStep = integratedDrivesCurrentStep;
  }

  return (
    !isStartStep(currentStep) &&
    partnerPreferences === null && (
      <div className="TopHeader print:hidden" {...props}>
        {fullScreen ? (
          <div className="z-fullScreen relative w-full sub-header select-none flex border-b-2 border-solid bg-primary border-y-hoverPrimary py-2 px-4 md:px-8">
            <div className="flex-1">
              <img
                src="https://www.se.com/ww/en/assets/564/media/202250/SE_logo-LIO-white_header.svg"
                alt="logo"
                className="h-6"
              />
            </div>

            <div className="md:flex md:visible justify-end items-center text-white text-xs">
              {seamlessSession !== null && window.getUserMenuOptionsFromMySchneider ? (
                <>
                  <qds-button
                    data-testid="menu-logged"
                    id="menu-logged"
                    text={seamlessSession.name}
                    action="dropdown"
                    icon-name="person"
                    icon-library="default"
                    importance="emphasized"
                  ></qds-button>
                  <qds-dropdown target="#menu-logged">
                    <div class="flex flex-col">
                      {window.getUserMenuOptionsFromMySchneider().map((opt, idx) => {
                        return (
                          <qds-list-item
                            divider="hide"
                            text={opt.label}
                            indeterminate
                            key={idx}
                            onClick={() => {
                              opt.handler();
                            }}
                          ></qds-list-item>
                        );
                      })}
                    </div>
                  </qds-dropdown>
                </>
              ) : (
                <qds-button
                  data-testid="button-login"
                  id="button-login"
                  text={t("msizer.core.header.login-register")}
                  icon-name="person"
                  icon-library="default"
                  importance="emphasized"
                  onClick={() => {
                    if (seamlessSession === null) {
                      document.location.href = buildMySchneiderUrl();
                    }
                  }}
                ></qds-button>
              )}
              {!isMobile && (
                <div className="align-middle fullscreen" onClick={() => handleSetFullScreen()}>
                  <AiOutlineFullscreenExit className="cursor-pointer text-base" />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="sub-header select-none flex py-1 px-2 absolute w-fit right-0">
            <div className="flex-1" />

            <div className="flex-1 flex justify-end items-center space-x-3 text-xs text-gray-600">
              <div onClick={() => handleSetFullScreen()}>
                <BsArrowsFullscreen className="cursor-pointer" />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default TopHeader;
